import { createFileRoute, redirect } from '@tanstack/react-router';

// Old carousel path; keep it so existing links still land somewhere.
export const Route = createFileRoute('/welcome')({
  beforeLoad: () => {
    throw redirect({ to: '/start', replace: true });
  },
});
